import { AvailableLanguages } from '@constants';
import { CandidateVerification } from './candidate-verification';
import { UserDocument } from './document';
import { ChangeRoutePayload } from './router';
import { User } from './user-auth';
import { UserProcess } from './user-process';

export enum InAppNotificationType {
  // NOTIFICATIONS that will be sent to EMPLOYEE ----------------------------
  FOREIGNER_SENT_PRE_SURVEY_FOR_VERIFICATION = 'FOREIGNER_SENT_PRE_SURVEY_FOR_VERIFICATION',
  FOREIGNER_SENT_APPLICATION_TO_VERIFICATION = 'FOREIGNER_SENT_APPLICATION_TO_VERIFICATION',
  FOREIGNER_ADDED_DOCUMENT_COMMENT = 'FOREIGNER_ADDED_DOCUMENT_COMMENT',
  FOREIGNER_SET_AVAILABILITY = 'FOREIGNER_SET_AVAILABILITY',
  DOCUMENTS_GENERATION_SUCCESS = 'DOCUMENTS_GENERATION_SUCCESS',
  DOCUMENTS_SENT_TO_EXTERNAL_SYSTEM_AND_GENERATED = 'DOCUMENTS_SENT_TO_EXTERNAL_SYSTEM_AND_GENERATED',
  DOCUMENTS_GENERATION_ERROR = 'DOCUMENTS_GENERATION_ERROR',
  CHECKLIST_GENERATION_SUCCESS = 'CHECKLIST_GENERATION_SUCCESS',
  CHECKLIST_GENERATION_ERROR = 'CHECKLIST_GENERATION_ERROR',
  FOREIGNER_HAS_BEEN_ASSIGNED_TO_YOU = 'FOREIGNER_HAS_BEEN_ASSIGNED_TO_YOU',
  FOREIGNER_SENT_MESSAGE_IN_CHAT = 'FOREIGNER_SENT_MESSAGE_IN_CHAT',
  FOREIGNER_CHANGED_PERSONAL_DETAILS = 'FOREIGNER_CHANGED_PERSONAL_DETAILS',
  FOREIGNER_SENDS_APPLICATION_WITH_POST = 'FOREIGNER_SENDS_APPLICATION_WITH_POST',
  FOREIGNER_APPLICATION_MODE_HAS_CHANGED = 'FOREIGNER_APPLICATION_MODE_HAS_CHANGED',
  FOREIGNER_PICKED_SIGNING_MODE = 'FOREIGNER_PICKED_SIGNING_MODE',
  FOREIGNER_CHANGED_PLANNED_DOCUMENTS_SIGNING_MODE = 'FOREIGNER_CHANGED_PLANNED_DOCUMENTS_SIGNING_MODE',
  FOREIGNER_CHANGED_PLANNED_DOCUMENTS_SIGNING_DATE = 'FOREIGNER_CHANGED_PLANNED_DOCUMENTS_SIGNING_DATE',
  FOREIGNER_PLANNING_TO_COME_TO_THE_OFFICE = 'FOREIGNER_PLANNING_TO_COME_TO_THE_OFFICE',
  FOREIGNER_CANCELLED_VISIT_IN_COMPANY_OFFICE = 'FOREIGNER_CANCELLED_VISIT_IN_COMPANY_OFFICE',
  FOREIGNER_ADDED_ITEMS_TO_REVIEW = 'FOREIGNER_ADDED_ITEMS_TO_REVIEW',
  FOREIGNER_SET_IMMIGRATION_OFFICE_VISIT_DATE = 'FOREIGNER_SET_IMMIGRATION_OFFICE_VISIT_DATE',
  FOREIGNER_CHANGED_IMMIGRATION_OFFICE_VISIT_DATE = 'FOREIGNER_CHANGED_IMMIGRATION_OFFICE_VISIT_DATE',
  FOREIGNER_UPLOADED_DECISION = 'FOREIGNER_UPLOADED_DECISION',

  FOREIGNER_MADE_PURCHASE = 'FOREIGNER_MADE_PURCHASE',

  // NOTIFICATIONS that will be sent to FOREIGNER ----------------------------
  // EMPLOYEE_CHANGED_DOCUMENT_STATUS = 'EMPLOYEE_CHANGED_DOCUMENT_STATUS',
  EMPLOYEE_ADDED_DOCUMENT_COMMENT = 'EMPLOYEE_ADDED_DOCUMENT_COMMENT',
  APPLICATION_STATUS_CHANGED = 'APPLICATION_STATUS_CHANGED',
  APPLICATION_STATUS_CHANGED_WITH_TYPE = 'APPLICATION_STATUS_CHANGED_WITH_TYPE',
  DOCUMENTS_LIST_CHANGED = 'DOCUMENTS_LIST_CHANGED',
  EMPLOYEE_SENT_MESSAGE_IN_CHAT = 'EMPLOYEE_SENT_MESSAGE_IN_CHAT',
  EMPLOYEE_CANCELLED_VOIVODESHIP_OFFICE_APPOINTMENT = 'EMPLOYEE_CANCELLED_VOIVODESHIP_OFFICE_APPOINTMENT',

  APPLICATION_MODE_CHANGED = 'APPLICATION_MODE_CHANGED',
  CONSULTANT_UPLOADED_DECISION = 'CONSULTANT_UPLOADED_DECISION',
  NEW_FINAL_VERIFICATION_COMMENTS = 'NEW_FINAL_VERIFICATION_COMMENTS',
  CHANGED_FINAL_VERIFICATION_COMMENTS = 'CHANGED_FINAL_VERIFICATION_COMMENTS',
  REASSIGNED_FOREIGNERS_TO_YOU = 'REASSIGNED_FOREIGNERS_TO_YOU',
  NEW_APPLICATION_HAS_BEEN_ADDED = 'NEW_APPLICATION_HAS_BEEN_ADDED',
  NEW_APPLICATION_HAS_BEEN_ADDED_WITH_TYPE = 'NEW_APPLICATION_HAS_BEEN_ADDED_WITH_TYPE',
  APPLICATION_HAS_BEEN_DELETED = 'APPLICATION_HAS_BEEN_DELETED',

  PARTNER_REQUESTED_PAYOUT = 'PARTNER_REQUESTED_PAYOUT',

  // CANDIDATE VERIFICATION NOTIFICATIONS
  MANAGER_STARTED_NEW_CANDIDATE_VERIFICATION = 'MANAGER_STARTED_NEW_CANDIDATE_VERIFICATION',
  CONSULTANT_STARTED_NEW_CANDIDATE_VERIFICATION = 'CONSULTANT_STARTED_NEW_CANDIDATE_VERIFICATION',
  CANDIDATE_FILLED_OPEN_FORM = 'CANDIDATE_FILLED_OPEN_FORM',
  CANDIDATE_FILLED_SUPPLEMENTARY_FORM = 'CANDIDATE_FILLED_SUPPLEMENTARY_FORM',
  CANDIDATE_VERIFICATION_SUPPLEMENTARY_INFO_REQUESTED = 'CANDIDATE_VERIFICATION_SUPPLEMENTARY_INFO_REQUESTED',
  CANDIDATE_REQUESTED_EXTENDING_TIME_FOR_FILLING_FORM = 'CANDIDATE_REQUESTED_EXTENDING_TIME_FOR_FILLING_FORM',
  CANDIDATE_REQUESTED_STOPPING_VERIFICATION = 'CANDIDATE_REQUESTED_STOPPING_VERIFICATION',
  MANAGER_CHANGED_CANDIDATE_VERIFICATION_PROCEDURES_LIST = 'MANAGER_CHANGED_CANDIDATE_VERIFICATION_PROCEDURES_LIST',
  CONSULTANT_CHANGED_CANDIDATE_VERIFICATION_PROCEDURES_LIST = 'CONSULTANT_CHANGED_CANDIDATE_VERIFICATION_PROCEDURES_LIST',
  CONSULTANT_SAVED_CANDIDATE_VERIFICATION_RESULT = 'CONSULTANT_SAVED_CANDIDATE_VERIFICATION_RESULT',
  CONSULTANT_ISSUED_CANDIDATE_VERIFICATION_DECISION = 'CONSULTANT_ISSUED_CANDIDATE_VERIFICATION_DECISION',
  MANAGER_ISSUED_CANDIDATE_VERIFICATION_DECISION = 'MANAGER_ISSUED_CANDIDATE_VERIFICATION_DECISION',
  CANDIDATE_VERIFICATION_DELETED = 'CANDIDATE_VERIFICATION_DELETED',

  // --- NEW APPOINTMENTS SYSTEM NOTIFICATIONS ---
  FOREIGNER_REQUESTED_APPOINTMENT_DATE = 'FOREIGNER_REQUESTED_APPOINTMENT_DATE',
  FOREIGNER_CHANGED_REQUESTED_APPOINTMENT = 'FOREIGNER_CHANGED_REQUESTED_APPOINTMENT',
  FOREIGNER_CANCELLED_APPOINTMENT = 'FOREIGNER_CANCELLED_APPOINTMENT',

  CONSULTANT_CREATED_APPOINTMENT = 'CONSULTANT_CREATED_APPOINTMENT',
  CONSULTANT_ACCEPTED_APPOINTMENT_DATE = 'CONSULTANT_ACCEPTED_APPOINTMENT_DATE',
  CONSULTANT_REJECTED_APPOINTMENT_DATE = 'CONSULTANT_REJECTED_APPOINTMENT_DATE',
  CONSULTANT_CANCELLED_APPOINTMENT = 'CONSULTANT_CANCELLED_APPOINTMENT',
  CONSULTANT_UPDATED_APPOINTMENT = 'CONSULTANT_UPDATED_APPOINTMENT',

  // --- WORK-PERMITS ---
  // to FOREIGNER
  WORK_PERMIT_LINKED_TO_ACCOUNT = 'WORK_PERMIT_LINKED_TO_ACCOUNT',
  WORK_PERMIT_DOCUMENTS_LIST_CHANGED = 'WORK_PERMIT_DOCUMENTS_LIST_CHANGED',
  WORK_PERMIT_DOCUMENT_APPROVED = 'WORK_PERMIT_DOCUMENT_APPROVED',
  WORK_PERMIT_DOCUMENT_REJECTED = 'WORK_PERMIT_DOCUMENT_REJECTED',
  WORK_PERMIT_STATUS_CHANGED = 'WORK_PERMIT_STATUS_CHANGED',
  // to EMPLOYEE assigned to the linked foreigner
  FOREIGNER_UPLOADED_WORK_PERMIT_DOCUMENTS = 'FOREIGNER_UPLOADED_WORK_PERMIT_DOCUMENTS',
}

export interface InAppNotificationData {
  causedBy: string | null; // name+surname or email of user causing the change (author) or null if system
  additionalInfo: { [key: string]: any }; // any additional data specific to particular notification type
}

export interface NotificationIconConfig {
  name: string;
  className: string;
  fontSet?: string;
}

export interface InAppNotification {
  id: string;
  read: boolean;
  readDate: string;
  type: InAppNotificationType;
  data: InAppNotificationData;
  recipientId: string;
  recipient: User;
  relatedForeignerId?: string | null;
  relatedForeigner?: User | null;
  relatedUserProcessId?: string | null;
  relatedUserProcess?: UserProcess | null;
  relatedUserDocumentId?: string | null;
  relatedUserDocument?: UserDocument | null;
  relatedCandidateVerificationId?: string | null;
  relatedCandidateVerification?: CandidateVerification | null;
  relatedWorkPermitId?: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;

  stacked?: boolean;
  stackSize?: number;
  stackedIds?: string[];
  clickable?: boolean;
  foreignerName?: string;
  documentName?: string;
  origError?: string;
  linkParams?: ChangeRoutePayload | null;
  icons?: NotificationIconConfig[];
}

export interface MarkAllOfTypeAsReadOpts {
  inAppNotificationType: InAppNotificationType;
  relatedUserDocumentId?: string;
  relatedUserProcessId?: string;
  relatedCandidateVerificationId?: string;
  // only when employee
  relatedForeignerId?: string;
}

export interface MarkAllOfTypeAsReadBulkOpts {
  inAppNotificationTypes: InAppNotificationType[];
  relatedUserDocumentId?: string;
  relatedUserProcessId?: string;
  relatedCandidateVerificationId?: string;
  relatedWorkPermitId?: string;
  // only when employee
  relatedForeignerId?: string;
}

export interface MaintenanceInfo {
  maintenanceUpcoming: boolean | null;
  message: { [key in AvailableLanguages]: string } | null;
}

export interface PromotionalBanner {
  promotionalBannerIsActive: boolean;
  promotionalBannerMessage: { [key in AvailableLanguages]: string };
}

export interface EmailHTMLNotification {
  subject: string;
  body_as_text: string;
  body_as_html: EmailHTMLBody;
}

export interface EmailHTMLBody {
  title?: string;
  subtitle?: string;
  cta_text?: string;
  cta_button_text?: string;
  cta_button_link?: string;
  cta_button_not_working_text?: string;
  sub?: string;

  extra_info?: string;

  assistant_assigned_no_info?: string;
  assistant_assigned_contact_us?: string;
  assistant_assigned_person_info?: string;
}
